import PLAY_BTN from "../icons/aimax-favicon-color.svg";

import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const VideoTitle = ({ title, overview, genre_ids, id }) => {
  const genreIdList = useSelector((store) => store.movies?.moviesGenreIds);

  if (!genreIdList) return;
  const filtered = genreIdList.filter((genre) => genre_ids.includes(genre.id));
  // console.log("filtered", filtered);

  return (
    <div className="px-6 md:px-16 pt-[25%] md:pt-[20%] w-full aspect-video absolute text-white md:bg-gradient-to-r from-black">
      <h1 className="text-2xl md:text-5xl font-semibold">{title}</h1>
      <div className="hidden md:flex my-2 brightness-50 ">
        {filtered.map((genre, index) => (
          <div key={genre.id}>
            {index > 0 && <span className="px-2">·</span>}
            {genre.name}
          </div>
        ))}
      </div>
      <p className="text-md w-2/4 text-justify	hidden lg:inline-block">
        {overview}
      </p>
      <div className="mt-2 flex md:justify-start gap-2">
        <Link to={`movie/${id}`}>
          <button className="bg-white px-4  py-2 text-[#0e0d26] font-semibold md:text-xl rounded-md flex items-center   hover:brightness-50 ">
            <img src={PLAY_BTN} alt="" className="w-6" />
            <p className="hidden md:inline-block">Go to Movie</p>
          </button>
        </Link>
      </div>
    </div>
  );
};

export default VideoTitle;
